import React, { Component } from 'react'

import { connect } from 'react-redux'

import Table from './Table'
import Collapse from './Collapse'
import InputCounter from './InputCounter'
import HeaderTitle from './HeaderTitle'

import { getEquipmentCount } from '../store/actions/SummaryActions'
import { updateEquipmentCount, addReduceEquipmentCount } from '../store/actions/EquipmentActions'

class Equipment extends Component {

    state = {
        collapseKeys: undefined,
    }

    updateEquipmentCount(id, newValue) {
        this.props.updateEquipmentCount(id, newValue);
        
        if((this.props.getEquipmentCount() <= 0 || Object.keys(this.props.EquipmentReducer.EquipmentSelected).length <= 1) && 
            this.props.isSelectedEquipmentTableOpen) 
        {
            this.props.toggleSelectedEquipment();
        }
    }
    addReduceEquipmentCount(id, isAdding) {
        this.props.addReduceEquipmentCount(id, isAdding);
        if((this.props.getEquipmentCount() <= 0 || Object.keys(this.props.EquipmentReducer.EquipmentSelected).length <= 1) && 
            this.props.isSelectedEquipmentTableOpen) 
        {
            this.props.toggleSelectedEquipment();
        }
    }

    onCollapseChanged(keys) {
        this.setState({
            ...this.state,
            collapseKeys: keys,
        })
    }
    
    render() {
        const { collapseKeys } = this.state;
        const { EquipmentInfo, EquipmentSelected } = this.props.EquipmentReducer;
        const { isSelectedEquipmentTableOpen, toggleSelectedEquipment } = this.props;

        var selectedItems = [];
        Object.keys(EquipmentInfo).forEach((key, i) => {
            const items = EquipmentInfo[key];
            (items.forEach(item => {
                if(EquipmentSelected[item.id] && Number(EquipmentSelected[item.id]) > 0) {
                    selectedItems.push([
                        <a {...{[item.vdLink ? "href" : undefined]:item.vdLink}} alt={item.name} target="_blank">
                            <img 
                                style={{height: "75px", "width": "100px", objectFit: "cover"}}
                                alt={item.name}
                                src={require(`../assets/equipment/${item.id}_large.png`)}
                            />
                        </a>,
                        item.name,
                        `$${item.price}`,
                        <InputCounter 
                            center
                            placeholder="Quantity"
                            onAdd={() => this.addReduceEquipmentCount(item.id, true)}
                            onReduce={() => this.addReduceEquipmentCount(item.id, false)}
                            onChange={(e) => this.updateEquipmentCount(item.id, e.target.value)}
                            value={EquipmentSelected[item.id] ? EquipmentSelected[item.id] : ""}
                        />
                    ])
                }
            }))
        })

        const selectedEquipment = (
            <Table title="Your Selected Devices" items={[
                ["Image","Name","Price","Qty"],
                ...selectedItems
            ]} />
        );
        
        const collapseItems = Object.keys(EquipmentInfo).map((key, i) => {
            const items = EquipmentInfo[key];

            return (
                {
                    headerTitle: 
                        <HeaderTitle 
                            titleLeft={key}
                            titleRight={collapseKeys == i ? "" : "Open"}
                        />,
                    content: (
                        <Table items={[
                            ["Image","Name","Price","Qty"],
                            ...(items.map(item => {
                                return [
                                    <a {...{[item.vdLink ? "href" : undefined]:item.vdLink}} alt={item.name} target="_blank">
                                        <img 
                                            style={{height: "75px", "width": "100px", objectFit: "cover"}}
                                            alt={item.name}
                                            src={require(`../assets/equipment/${item.id}_large.png`)}
                                        />
                                    </a>,
                                    item.name,
                                    `$${item.price}`,
                                    <InputCounter 
                                        center
                                        placeholder="Quantity"
                                        onAdd={() => this.addReduceEquipmentCount(item.id, true)}
                                        onReduce={() => this.addReduceEquipmentCount(item.id, false)}
                                        onChange={(e) => this.updateEquipmentCount(item.id, e.target.value)}
                                        value={EquipmentSelected[item.id] ? EquipmentSelected[item.id] : ""}
                                    />
                                ]
                            }))
                        ]} />
                    )
                }
            )
        });

        return (
            <div id="equipment">
                {isSelectedEquipmentTableOpen && selectedEquipment}
                <div className="sub-title" style={{margin: "2.5vh 2.5vw"}}>Need to buy phones?<br/><u>Limited Time Offer:</u> Up to 10% of equipment purchase is credited back against 2nd month MRC billing
                </div>
                    {
                        <Collapse
                            onlyOneOpened
                            onChange={(keys) => this.onCollapseChanged(keys)}
                            items={collapseItems}
                        />
                        /* Object.keys(EquipmentInfo).map((key, i) => {
                            const items = EquipmentInfo[key];
                            return (
                                <Collapse
                                    key={key}
                                    onlyOneOpened
                                    onChange={(keys) => this.onCollapseChanged(keys)}
                                    items={[
                                        {
                                            headerTitle: 
                                                <HeaderTitle 
                                                    titleLeft={key}
                                                    titleRight={collapseKeys.find(item => item == i) ? "" : "Open"}
                                                />,
                                            content: (
                                                <Table items={[
                                                    ["Image","Name","Price","Qty"],
                                                    ...(items.map(item => {
                                                        return [
                                                            <img 
                                                                style={{height: "75px", "width": "100px", objectFit: "cover"}}
                                                                alt={item.name}
                                                                src={require(`../assets/equipment/${item.id}_large.png`)}
                                                            />,
                                                            item.name,
                                                            `$${item.price}`,
                                                            <InputCounter 
                                                                center
                                                                placeholder="Quantity"
                                                                onAdd={() => this.addReduceEquipmentCount(item.id, true)}
                                                                onReduce={() => this.addReduceEquipmentCount(item.id, false)}
                                                                onChange={(e) => this.updateEquipmentCount(item.id, e.target.value)}
                                                                value={EquipmentSelected[item.id] ? EquipmentSelected[item.id] : ""}
                                                            />
                                                        ]
                                                    }))
                                                ]} />
                                            )
                                        }
                                    ]}
                                />
                            )
                        }) */
                    }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        EquipmentReducer: state.EquipmentReducer,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        updateEquipmentCount: (id, newValue) => dispatch(updateEquipmentCount(id, newValue)),
        addReduceEquipmentCount: (id, isAdding) => dispatch(addReduceEquipmentCount(id, isAdding)),
        getEquipmentCount: () => dispatch(getEquipmentCount()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Equipment);